import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-97" data-mp="1mf2ctd0ek2u7">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-98" data-mp="1mgna3ae3pzvr">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/15 text-brand-orange" data-id="element-99" data-mp="1hnalv1dc3v3j">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-100" data-mp="1wf2xb2a0cozz" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-101" data-mp="1rddm9mmscbbw">⚡ What Do You Get Instantly?</h2>
        <div className="space-y-3 text-left" data-id="element-102" data-mp="25cvfce746ar2">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-103" data-mp="20fd58khd1phh">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-104" data-mp="61lzvx62drru" />
              <span className="font-semibold" data-id="element-105" data-mp="2n2q4lyetzl27">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-purple" data-id="element-106" data-mp="2s1tb7naglzca">You never run out of material.</p>
      </Reveal>
    </section>;
}